import _ from "lodash";
import React from "react";
import classes from "./ActionBar.scss";
import { onEnterOrSpaceKeyDown } from "Utils";
import UIButton from "UIComponents/UIButton";
import I18nHOC from "UIComponents/I18nHOC";
import { CloseIcon } from "SvgComponents";

import { CloseOutlined, InformationFilled } from "@toddle-edu/ds-icons";
import { Button } from "@toddle-edu/ds-web";

import { colors } from "Constants";
const ActionIcons = [
  {
    action: "REJECT_ALL",
    label: "journal:return_all",
    color: colors.neutral400,
    buttonType: "text",
  },
  {
    action: "APPROVE_ALL",
    label: "journal:approve_all",
    color: "blue",
    buttonType: "normal",
  },
];

const ActionIconsV2 = [
  {
    action: "APPROVE_ALL",
    label: "journal:approve_all",
    color: colors.link29,
    buttonType: "text",
  },
];

const ActionButtons = React.memo(props => {
  const { onActionClick, onCloseClick, t, showDesignV2 } = props;

  const onActionCardKeydown = action => e => {
    onEnterOrSpaceKeyDown(e, () => onActionClick({ action }));
  };

  return (
    <div className={classes.actionButtonsContainer}>
      {_.map(showDesignV2 ? ActionIconsV2 : ActionIcons, item => {
        return item.buttonType == "normal" ? (
          <UIButton
            key={item.action}
            size={"sm"}
            type={"filled"}
            color={item.color}
            onClick={() => onActionClick({ action: item.action })}
            onKeyDown={onActionCardKeydown(item.action)}
          >
            {t(item.label)}
          </UIButton>
        ) : showDesignV2 ? (
          <Button
            tabIndex={0}
            variant={"inline-progressive"}
            onClick={() => onActionClick({ action: item.action })}
            onKeyDown={onActionCardKeydown(item.action)}
          >
            {t(item.label)}
          </Button>
        ) : (
          <div
            tabIndex={0}
            key={item.action}
            className={classes.buttonText}
            style={{ color: item.color }}
            onClick={() => onActionClick({ action: item.action })}
            onKeyDown={onActionCardKeydown(item.action)}
          >
            {t(item.label)}
          </div>
        );
      })}
    </div>
  );
});

ActionButtons.displayName = "ActionButtons";

class ActionBar extends React.PureComponent {
  render() {
    const {
      selectedItems,
      totalCount,
      onActionClick,
      onCloseClick,
      t,
      showDesignV2,
    } = this.props;
    const handleCloseKeyDown = e => {
      onEnterOrSpaceKeyDown(e, onCloseClick);
    };
    return showDesignV2 ? (
      <div className={classes.containerV2}>
        <div className={classes.leftContainerV2}>
          <div className={classes.countText}>
            <span style={{ marginRight: "8px", marginTop: "4px" }}>
              <InformationFilled variant={"link"} />
            </span>
            {t("journal:count_posts_pending_approval", { count: totalCount })}
          </div>
        </div>
        <div className={classes.rightContainerV2}>
          <ActionButtons
            t={t}
            selectedItems={selectedItems}
            onActionClick={onActionClick}
            onCloseClick={onCloseClick}
            showDesignV2={showDesignV2}
          />
          <div
            tabIndex={0}
            className={classes.cancelIcon}
            onClick={onCloseClick}
            onKeyDown={handleCloseKeyDown}
          >
            <CloseOutlined variant={"subtle"} />
          </div>
        </div>
      </div>
    ) : (
      <div className={classes.container}>
        <div className={classes.leftContainer}>
          <div className={classes.countText}>
            {t("journal:count_posts_pending_approval", { count: totalCount })}
          </div>
          <div>
            <ActionButtons
              t={t}
              selectedItems={selectedItems}
              onActionClick={onActionClick}
              onCloseClick={onCloseClick}
            />
          </div>
        </div>
        <div className={classes.cancelIcon} onClick={onCloseClick}>
          <CloseIcon width={16} height={16} />
        </div>
      </div>
    );
  }
}

export default I18nHOC({ resource: ["common", "journal"] })(ActionBar);
